import { compose } from 'redux'
import { connect } from 'react-redux'

import { reduxForm ,getFormValues} from 'redux-form'

const mapStateToProps = (state, props) => {
    const { DinamicCustomFormsReducer } = state
    const controler = DinamicCustomFormsReducer.rLista;
    let lista = controler.lista;
    let customForm = null;
    lista.forEach(f => {
        if (f.uid === props.item.customFormUid) {
            customForm = f;
        }
    });
    const { initialValues } = props
    
    
    let atualValues = getFormValues('CrudInterno' + props.item.field)(state)

    return {
        form: 'CrudInterno' + props.item.field,
        customForm,
        initialValues,atualValues
    };
};


export default compose(

    connect(mapStateToProps, {}),
    reduxForm(),


);


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/TabelaItensCustomForm/CadastroItem/CadastroItem.enhancer.js